import { extendObservable, computed, action } from 'mobx';
import FeedbackChain from '../models/FeedbackChain';
import axios from '../../../libs/axios_csrf';
import { snakeCase, camelCase } from '@ridi/object-case-converter';

export default class FeedbackChainsStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    extendObservable(this, {
      loading: false,
      lastFeedbackPath: undefined
    });
  }

  get attachmentsStore() {
    return this.rootStore.attachmentsStore;
  }

  buildFeedbackChain() {
    const feedbackChain = new FeedbackChain(this, '', false);
    return feedbackChain;
  }

  @action clearLastFeedbackPath() {
    this.lastFeedbackPath = undefined;
  }

  @action
  createBackend(feedbackChain) {
    this.loading = true;
    axios
      .post('/feedback_chains.json', {
        feedback_chain: snakeCase(feedbackChain.serialize())
      })
      .then(
        action(async response => {
          const feedbackChainJson = camelCase(
            response.data.feedback_chain,
            true
          );
          feedbackChain.setId(feedbackChainJson.id);
          feedbackChain.setPersisted(true);
          this.lastFeedbackPath = feedbackChainJson.feedbackChainNotifiablePath;
          await feedbackChain.persistAttachments();
          this.loading = false;
        })
      )
      .catch(
        action(function(error) {
          this.loading = false;
          console.log(error);
        })
      );
  }
  // end BACKEND CONNECTIONS
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
